import { createSelector, createSlice } from '@reduxjs/toolkit';
import * as ThunkHelpers from '../api/thunk.helper';
import { LabelValuePair } from '../interfaces';
import {
  GuidanceStore,
  SearchGLGuidanceForCatalogRequest,
  SearchGLGuidanceForCatalogResponse,
  SearchReportingEntitiesResponse
} from './guidanceCode.interfaces';

// Actions
export const searchGLGuidanceForCatalog = ThunkHelpers.createServicesThunk<
  SearchGLGuidanceForCatalogRequest,
  SearchGLGuidanceForCatalogResponse
>({
  path: 'Catalog/SearchGLGuidanceForCatalog',
  useLoadingIndicator: true
});

export const searchReportingEntities = ThunkHelpers.createServicesThunk<
  {},
  SearchReportingEntitiesResponse
>({
  path: 'Billing/SearchReportingEntities',
  useLoadingIndicator: true
});

const EMPTY_ARRAY: any[] = [];
// Reducer
const initialState: GuidanceStore = {
  guidanceCodes: [],
  reportingEntities: EMPTY_ARRAY
};

const slice = createSlice({
  name: 'glGuidance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(searchGLGuidanceForCatalog.fulfilled, (state, action) => {
      state.guidanceCodes = action.payload.GLGuidanceConfiguration;
    });
    builder.addCase(searchReportingEntities.fulfilled, (state, action) => {
      state.reportingEntities = action.payload.data || EMPTY_ARRAY;
    });
  }
});

export const guidanceActions = slice.actions;
export default slice.reducer;

// Selectors
const GlGuidanceState = (state: { core: { glGuidance: GuidanceStore } }) =>
  state.core.glGuidance;

export const GuidanceCodesSelector = createSelector(
  [GlGuidanceState],
  (state) =>
    state.guidanceCodes.map((guidanceCode) => {
      return {
        id: guidanceCode.Name,
        name: guidanceCode.DisplayName,
        description: guidanceCode.Description
      };
    })
);

export const ReportingEntitiesSelector = createSelector(
  [GlGuidanceState],
  (state): LabelValuePair[] =>
    state.reportingEntities.map((reportingEntity) => {
      return {
        label: reportingEntity.name,
        value: reportingEntity.name
      };
    })
);
